import React from "react";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";
import Modal from "@material-ui/core/Modal";
import TextField from "@material-ui/core/TextField";
import ReactPaginate from "react-paginate";
import dataShare from "../../Common/dataShare";
import "./ManageDocumentTypesStyle.css";

export default class ManageDocumentTypesComponent extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            rows: [],
            loading: false,
            showModal: false,
            modalMode: "create",
            selectedRow: null,
            form: { display: "", value: "" },
            error: { display: false, value: false },
            showRetired: false,
            currentPage: 0,
            recordsPerPage: 10,
            sortColumn: "display",
            sortDirection: "asc"
        };
    }

    componentDidMount = () => {
        if (this.props.showManageDocumentTypes) this.loadRows();
    }

    componentDidUpdate = (prevProps) => {
        if (this.props.showManageDocumentTypes && !prevProps.showManageDocumentTypes) {
            this.loadRows();
        }
    }

    getVisibleRows = () => {
        const visibleRows = this.state.rows
            .filter((row) => this.state.showRetired || !row.isRetired)
            .slice();

        if (!this.state.sortColumn) return visibleRows;

        return visibleRows.sort((a, b) => {
                if (this.state.showRetired && a.isRetired !== b.isRetired) {
                    return a.isRetired ? 1 : -1;
                }

            const first = (a[this.state.sortColumn] || "").toLowerCase();
            const second = (b[this.state.sortColumn] || "").toLowerCase();
            const comparison = first.localeCompare(second);
            return this.state.sortDirection === "asc" ? comparison : -comparison;
            });
    }

    loadRows = () => {
        this.setState({ loading: true });
        dataShare.getDocumentTypesManage((error, response) => {
            if (error) {
                this.props.showNotification("error", "Failed to load document types.");
                this.setState({ loading: false });
                return;
            }
            const rows = Array.isArray(response) ? response.slice() : [];
            this.setState({ rows, loading: false, currentPage: 0 });
        });
    }

    openCreate = () => {
        this.setState({ showModal: true, modalMode: "create", selectedRow: null, form: { display: "", value: "" }, error: { display: false, value: false } });
    }

    openEdit = (row) => {
        this.setState({
            showModal: true,
            modalMode: "update",
            selectedRow: row,
            form: { display: row.display || "", value: row.value || "" },
            error: { display: false, value: false }
        });
    }

    closeModal = () => {
        this.setState({ showModal: false, selectedRow: null, error: { display: false, value: false } });
    }

    inputChanged = (event) => {
        const next = {};
        next[event.target.name] = event.target.value;
        this.setState({
            form: { ...this.state.form, ...next },
            error: {
                ...this.state.error,
                display: event.target.name === "display" ? false : this.state.error.display,
                value: event.target.name === "value" ? false : this.state.error.value
            }
        });
    }

    saveModal = () => {
        const display = (this.state.form.display || "").trim();
        const value = (this.state.form.value || "").trim();

        if (this.state.modalMode === "create" && !display) {
            this.setState({ error: { ...this.state.error, display: true } });
            return;
        }

        if (this.state.modalMode === "create" && !value) {
            this.setState({ error: { ...this.state.error, value: true } });
            return;
        }

        if (!display || !value) {
            this.props.showNotification("warning", "Display and Value are required.");
            return;
        }

        if (this.state.modalMode === "create") {
            dataShare.createDocumentType({ display, value }, (error) => {
                if (error) {
                    const message = error.response && error.response.data ? error.response.data : "Failed to create document type.";
                    this.props.showNotification("error", message);
                    return;
                }
                this.closeModal();
                this.props.showNotification("success", "Document type created.");
                this.loadRows();
            });
            return;
        }

        if (!this.state.selectedRow) return;
        dataShare.updateDocumentType(this.state.selectedRow.id, {
            display,
            value
        }, (error) => {
            if (error) {
                const message = error.response && error.response.data ? error.response.data : "Failed to update document type.";
                this.props.showNotification("error", message);
                return;
            }
            this.closeModal();
            this.props.showNotification("success", "Document type updated.");
            this.loadRows();
        });
    }

    toggleRetire = (row) => {
        const action = row.isRetired ? dataShare.reinstateDocumentType : dataShare.retireDocumentType;
        action(row.id, (error) => {
            if (error) {
                const message = error.response && error.response.data ? error.response.data : "Failed to update document type status.";
                this.props.showNotification("error", message);
                return;
            }
            this.props.showNotification("success", row.isRetired ? "Document type reinstated." : "Document type retired.");
            this.loadRows();
        });
    }

    toggleRetiredView = () => {
        this.setState((prevState) => ({ showRetired: !prevState.showRetired, currentPage: 0 }));
    }

    handlePageChange = (obj) => {
        this.setState({ currentPage: obj.selected });
    }

    sortBy = (column) => {
        this.setState((previousState) => ({
            sortColumn: column,
            sortDirection: previousState.sortColumn === column && previousState.sortDirection === "asc" ? "desc" : "asc",
            currentPage: 0
        }));
    }

    renderSortHeader = (column, label) => {
        return (
            <button type="button" className="MDT-sortHeader" onClick={() => this.sortBy(column)}>
                {label}
                <i className="material-icons" aria-hidden="true">unfold_more</i>
            </button>
        );
    }

    renderTable = () => {
        const visibleRows = this.getVisibleRows();
        const start = this.state.currentPage * this.state.recordsPerPage;
        const pagedRows = visibleRows.slice(start, start + this.state.recordsPerPage);

        if (this.state.loading) {
            return <p className="MDT-empty">Loading document types...</p>;
        }

        if (visibleRows.length === 0) {
            return (
                <p className="MDT-empty">
                    {this.state.showRetired ? "No document types configured." : "No active document types configured."}
                </p>
            );
        }

        return (
            <Table className="MDT-table">
                <TableHead className="MDT-tableHead">
                    <TableRow className="MDT-headRow">
                        <TableCell className="MDT-headCell">{this.renderSortHeader("display", "Display")}</TableCell>
                        <TableCell className="MDT-headCell">{this.renderSortHeader("value", "Value")}</TableCell>
                        <TableCell className="MDT-headCell">Actions</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {pagedRows.map((row) => (
                        <TableRow key={row.id} className={"MDT-row " + (row.isRetired ? "retired" : "")}>
                            <TableCell className="MDT-cell">{row.display}</TableCell>
                            <TableCell className="MDT-cell">{row.value}</TableCell>
                            <TableCell className="MDT-cell action">
                                {row.isRetired ? (
                                    <i className="material-icons" title="Reinstate" onClick={() => this.toggleRetire(row)}>restore</i>
                                ) : (
                                    <React.Fragment>
                                        <i className="material-icons" title="Edit" onClick={() => this.openEdit(row)}>settings</i>
                                        <i className="material-icons" title="Retire" onClick={() => this.toggleRetire(row)}>delete</i>
                                    </React.Fragment>
                                )}
                            </TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        );
    }

    renderPagination = () => {
        const visibleRows = this.getVisibleRows();
        const pageCount = Math.ceil(visibleRows.length / this.state.recordsPerPage);

        if (pageCount <= 1) return null;

        return (
            <div className="MDT-tableFooter MDT-paginationWrap">
                <ReactPaginate
                    previousLabel={<i className="material-icons">keyboard_arrow_left</i>}
                    nextLabel={<i className="material-icons">keyboard_arrow_right</i>}
                    breakLabel="..."
                    breakClassName={"break-me"}
                    pageCount={pageCount}
                    marginPagesDisplayed={1}
                    pageRangeDisplayed={3}
                    onPageChange={this.handlePageChange}
                    containerClassName={"pagination"}
                    subContainerClassName={"pages pagination"}
                    forcePage={this.state.currentPage}
                    activeClassName={"active appSecondaryBGClr"}
                />
            </div>
        );
    }

    renderModal = () => (
        <Modal open={this.state.showModal} onClose={this.closeModal} style={{ zIndex: 9999 }}>
            <div className="MDT-modalOverlay">
                <Grid container spacing={0}>
                    <Grid item xs={12} sm={10} md={9} lg={6} className="MDT-modalWrapper">
                        <div className="MDT-modalContainer">
                            <span className="MDT-closeBtn" onClick={this.closeModal}>
                                <i className="material-icons">clear</i>
                            </span>
                            <h2 className="MDT-modalTitle">{this.state.modalMode === "create" ? "New Document Type" : "Edit Document Type"}</h2>
                            <TextField
                                name="display"
                                label="Display"
                                InputLabelProps={{ shrink: true }}
                                placeholder="Enter display label"
                                fullWidth
                                margin="normal"
                                value={this.state.form.display}
                                onChange={this.inputChanged}
                            />
                            {
                                this.state.error.display && <span className="errorMessage">Display Required</span>
                            }
                            <TextField
                                name="value"
                                label="Value"
                                InputLabelProps={{ shrink: true }}
                                placeholder="Must match LOS document type exactly"
                                fullWidth
                                margin="normal"
                                value={this.state.form.value}
                                onChange={this.inputChanged}
                                helperText="Value must match the LOS document type name exactly."
                            />
                            {
                                this.state.error.value && <span className="errorMessage">Value Required</span>
                            }
                            <div className="MDT-modalFooter">
                                <Button variant="contained" className="cancelBtn appSecondaryClr" onClick={this.closeModal}>Cancel</Button>
                                <Button variant="contained" className="createBtn appSecondaryBGClr" onClick={this.saveModal}>{this.state.modalMode === "create" ? "Add" : "Update"}</Button>
                            </div>
                        </div>
                    </Grid>
                </Grid>
            </div>
        </Modal>
    )

    render() {
        return (
            <div className={this.props.showManageDocumentTypes ? "fixed-right open" : "fixed-right"}>
                <div className="MDT-header">
                    Manage Document Types
                    <i className="material-icons" onClick={this.props.toggleManageDocumentTypes}>close</i>
                </div>
                <p className="MDT-subtitle">Configure the document type catalog used by uploads and LOS forwarding.</p>
                <div className="MDT-actionRow">
                    <label className="MDT-showRetiredCheck">
                        <input
                            type="checkbox"
                            checked={this.state.showRetired}
                            onChange={this.toggleRetiredView}
                        />
                        <span>Show retired</span>
                    </label>
                    <Button variant="contained" className="addNewTypeBtn" onClick={this.openCreate}>+ New Type</Button>
                </div>
                <div className="MDT-listWrapper">
                    {this.renderTable()}
                </div>
                {this.renderPagination()}
                {this.renderModal()}
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/admin/components/Main/ManageDocumentTypes/ManageDocumentTypes.js